import React from 'react';
import { BiInfoCircle } from 'react-icons/bi';
import { Tooltip } from 'antd';
import { YbotWindowContext } from './ybotScreenLib';
import { DockContextTrigger } from './ybotDockStyledComponents';

interface YbotMessageContextProps {
  context: YbotWindowContext;
}

/**
 * Where a prompt was sent from, on the message itself. Quiet by design: the answer is the point,
 * this is only here for the moment someone wonders what the bot was looking at. Almost invisible
 * until hovered or focused.
 */
const YbotMessageContext: React.FC<YbotMessageContextProps> = ({ context }) => {
  const lines = [
    context.project === undefined ? undefined : `Project: ${context.project}`,
    context.screen?.url === undefined ? undefined : `Sent from: ${context.screen.url}`,
  ].filter((line): line is string => line !== undefined);

  if (lines.length === 0) {
    return null;
  }

  // The database is deliberately not shown. It is a hint for phase 2's tools, not something the
  // reader of a chat needs, and it would be the longest line here.
  const title = (
    <>
      {lines.map(line => (
        <div key={line}>{line}</div>
      ))}
    </>
  );

  return (
    <Tooltip title={title}>
      <DockContextTrigger type="button" aria-label="Sent from">
        <BiInfoCircle />
      </DockContextTrigger>
    </Tooltip>
  );
};

export default YbotMessageContext;
